import React, {useEffect, useRef} from "react";
import GenderImage from "../assets/sloth/genders.png"
import { useInView } from "react-intersection-observer";
import gsap from "gsap";
import Ticker from "../components/smsc/Ticker";
import { Fade } from "react-awesome-reveal";

const GenderBox = (props) => {
    return(
        <div>
        <h3 className="h3">
            {props.gender}
        </h3>
        <p className="pt-[8px] lg:pt-[32px] subtitle">
            Supply: <Ticker end={props.supply}/>
        </p>
    </div>

    )
}


function RightLeaf(props) {
    return (
      <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="88.37 32.75 283.78 396.31"
        {...props}
      >
        <path
          d="M324.821 139.419l10.771 18.935c-20.529 47.667-46.449 88.542-73.754 122.999l-17.113-34.465 6.354 47.641c-78.016 92.66-162.71 134.526-162.71 134.526 1.387-39.874 6.686-75.901 14.897-108.462l26.479-2.584-23.506-8.542c30.523-109.315 94.322-177.788 151.816-219.243l25.191 6.864-17.585-12.243c57.381-39.479 106.489-52.1 106.489-52.1-6.631 40.868-17.718 80.252-33.076 117.498l-14.253-10.824z"
          fill="#BBF0D2"
        />
        <path
          d="M363.615 40.767S153.762 237.157 93.271 419.98c0 0 47.919-145.189 270.344-379.213z"
          fill="#E6FFF1"
        />
        <path
          d="M298.86 111.855l-46.157-6.361 42.125 8.158 4.032-1.797zM263.149 154.007l-3.477 79.011-1.005-76.272 4.482-2.739zM232.77 188.801l-57.188 3.239 52.983.148 4.205-3.387zM185.388 253.208l-6.337 69.743 9.608-75.112-3.271 5.369zM151.966 298.098l-31.636 4.081 31.876-.882-.24-3.199zM131.837 340.539l.647 26.234-4.585-26.523 3.938.289z"
          fill="#E6FFF1"
        />
      </svg>
    )
  }


  function LeftLeaf(props) {
    return (
      <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-77.29 29.55 274.67 225.58"
        {...props}
      >
        <g>
          <path
            d="M-23.826 95.752l-4.012 15.37c23.455 29.699 49.426 53.597 75.16 72.713l5.55-27.505 4.515 34.755c72.437 50.541 139.991 64.044 139.991 64.044-8.502-27.822-19.033-52.198-30.962-73.582l-19.137 3.177 14.944-10.452C120.093 103.038 62.235 66.85 13.916 48.502l-16.448 9.589L7.543 46.149C-40.323 29.172-77.294 29.55-77.294 29.55c12.384 27.533 27.625 53.18 45.472 76.516l7.996-10.314z"
            fill="#0D3727"
          />
          <path
            d="M-69.767 33.59s184.871 98.72 261.981 216.073c0 0-61.152-93.219-261.981-216.074z"
            fill="#0D5137"
          />
          <path
            d="M-10.74 71.438l31.31-13.191-28.13 13.696-3.18-.505zM22.367 94.388l17.36 54.994-13.686-53.91-3.674-1.084zM50.33 113.161l40.89-8.512-37.29 10.104-3.6-1.592zM95.862 149.584l17.626 47.926-20.943-51.091 3.317 3.165zM127.871 174.893l23.053-3.096-22.618 5.395-.435-2.299zM150.057 200.988l4.495 18.599-1.776-19.546-2.719.947z"
            fill="#0D5137"
          />
        </g>
        <defs>
          <filter
            id="filter0_f_1021_7465"
            x={-91.293}
            y={15.5498}
            width={302.672}
            height={253.58}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur
              stdDeviation={7}
              result="effect1_foregroundBlur_1021_7465"
            />
          </filter>
        </defs>
      </svg>
    )
  }

const Genders = () => {

  const leftItem = useRef(null)
  const rightItem = useRef(null)

  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0.5,
    delay: 200,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      gsap.to(leftItem.current, {
        duration: 1,
        x: 0,
        opacity: 1,
        rotate: 0,
        skewX: 0,
        ease: "power1.inOut",
      });
      gsap.to(rightItem.current, {
        duration: 1,
        x: 0,
        rotate: 0,
        skewX: 0,
        opacity: 1,
        ease: "power1.inOut",
      });



    }
  }, [inView]);


    return(
        <section className="pt-[140px] lg:pt-[180px] text-center text-[#0D3727] relative" ref={ref}>
          
                <div className="container-theme ">
                  <Fade cascade duration={300}>
                <h2 className="body-1 font-[600]">
                The SMSC sloths are divided into two genders: male and female. <br/>This trait was revealed alongside the artwork 24 hours after the sale ended.
                </h2>

                <div className="grid grid-cols-2 uppercase pt-[50px] pb-[30px] lg:py-[60px] lg:px-[100px] container-theme">

                    <GenderBox gender={`Male`} supply={4500}/>
                    <GenderBox gender={`Female`} supply={1500}/>

        

                </div>

                <img src={GenderImage} className='lg:px-[100px] ' />
                </Fade>
                </div>

                <div ref={leftItem}  className="translate-x-[-10vw] -rotate-45 skew-x-12 absolute left-[-200px] w-[400px] h-[400px] top-[55%] hidden lg:block">
                        <LeftLeaf/>
                    </div>



                <div ref={rightItem} className="translate-x-[10vw] rotate-45 -skew-x-12 absolute right-[-79px] w-[150px] lg:right-[-200px] lg:w-[400px] h-[400px] top-[80%] lg:top-[55%] overflow-visible">
                        <RightLeaf/>
                    </div>

        </section>
    )
}

export default Genders